import React from 'react';
import { Card, Tag, Typography } from '@duxton-web/ui';

import { useVariableContext } from '@/features/variable/contexts/variable-context';
import ValidationContent from '@/features/variable/settings/validation/contextual/validation-content';
import { ContextualRule } from '@/lib/PlannerDTOs';

interface DefaultRuleProps {
  rule: ContextualRule;
  onRuleChange: (rule: ContextualRule) => void;
}

const DefaultRule = ({ rule, onRuleChange }: DefaultRuleProps) => {
  const { disabled } = useVariableContext();

  return (
    <Card
      size="small"
      title="Default (catch-all)"
      extra={<Typography.Metadata>Applies to all targets</Typography.Metadata>}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
          <Tag
            size="small"
            style={{
              marginInlineEnd: 0,
              height: 40,
              width: 56,
              fontWeight: 600,
              lineHeight: '34px',
              textAlign: 'center',
              fontSize: 12,
            }}
          >
            THEN
          </Tag>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <ValidationContent
              rule={rule}
              disabled={disabled}
              onRuleChange={onRuleChange}
            />
          </div>
        </div>
      </div>
    </Card>
  );
};

export default DefaultRule;
